define.alias("shared/helpers/moment-format", "settings/helpers/moment-format");